module.exports = "/images/refresh.svg?fbfd1b68316af7b3a3c111136d7d0c55";